import { ReactNode } from 'react';
import { Wrapper } from './Heading.styles';

interface HeadingProps {
  children?: ReactNode;
  'data-testid'?: string;
}

export const Heading = ({
  children,
  ['data-testid']: dataTestId,
}: HeadingProps) => <Wrapper data-testid={dataTestId}>{children}</Wrapper>;
